
import {Injectable} from '@angular/core';
import {Dictionary} from '../../models/dictionary.model';

@Injectable()

/// This service is only used for communication between two components accross a router-outlet tag.
/// This class should never contain any logic or state
export class RouterOutletService {
    constructor() {
        this.eventEmitterDictionary = new Dictionary([]);
    }
    public eventEmitterDictionary: Dictionary;

    // Do not reuse these constants - one string for every communication channel
    public insuranceSearchResultsFoundFunction: Function;
    public insuranceClearResultsFunction: Function;

    public addInsuranceFunction: Function;
    public clearSearchFunction: Function;
    public displayAddInsuranceFunction: Function;
    public setCanAddInsurance: Function;

}
